module.exports = __webpack_public_path__ + "static/mester-gronn-d1fab34dec63fd67a4c635903fde7e01.png";